import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import ToastPlugin from "./plugins/toast";
import "bootstrap-icons/font/bootstrap-icons";

Vue.use(ToastPlugin);
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
